export function formatPrice(val) {
  if (typeof val === "string") {
    val = val.replace(",", ".");
    val = parseFloat(val);
  }

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(val);
}
